import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../assets/background.png";

export default function LoadingScreen({ ...props }) {
  const [ellipses, setEllipses] = useState([]);

  function updateEllipses() {
    if (ellipses.length < 3) {
      setEllipses([...ellipses, "."]);
    } else {
      setEllipses([]);
    }
  }

  useEffect(() => {
    var timerID = setInterval(() => updateEllipses(), 500);
    return () => {
      clearInterval(timerID);
    };
  });

  return (
    <div
      style={{
        height: "100%",
        textAlign: "center",
        lineHeight: "700px",
        fontSize: "4em",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "0px -1px"
      }}
    >
      Loading{ellipses.join("")}
    </div>
  );
}
